export default function checkPassword(password) {
  if (password.length < 12) {
    alert('New Password is too short');
    return false;
  }
  if (password.length > 60) {
    alert('New Password is too long');
    return false;
  }
  if (!(/\d/.test(password))) {
    alert('New Password number contain at least one number');
    return false;
  }
  if (!(/[!@#\$%^\*&]/.test(password))) {
    alert('New Password number contain at least one special character');
    return false;
  }

  return true;
}

export const getPasswordErrors = (password) => {
  if (password.length < 8) {
    return 'New Password is too short';
  }
  if (password.length > 60) {
    return 'New Password is too long';
  }
  if (!(/\d/.test(password))) {
    return 'New Password number contain at least one number';
  }
  if (!(/[!@#\$%^\*&]/.test(password))) {
    return 'New Password number contain at least one special character';
  }
  return null;
};